export const SortingOptions = {

  portable: [
    {
      valueObj: {
        label: 'sortByPrice',
        value: 'ASC'
      },
      title: 'Cena: od najniższej',
    },
    {
      valueObj: {
        label: 'sortByPrice',
        value: 'DESC'
      },
      title: 'Cena: od najwyższej',
    },
  ],

  tv: [
    {
      valueObj: {
        label: 'sortByPrice',
        value: 'ASC'
      },
      title: 'Cena: od najniższej',
    },
    {
      valueObj: {
        label: 'sortByPrice',
        value: 'DESC'
      },
      title: 'Cena: od najwyższej',
    },
  ]

}



// WEBPACK FOOTER //
// src/js/controllers/offers/finOffers/forhomeSortingOptions.js